import { AppMenu, AppUserMenu } from '@/api/models';

interface IReportItem {
  appMenuId: number;
  name: string;
  uiName: string;
  parentAppMenuId: number;
}

type ReportsMap = Record<string, IReportItem>;

interface IGetReportSettingsProps {
  reportNames: any;
  appMenuId: number;
  appMenus: AppMenu[];
  userMenus: AppUserMenu[];
}

type BooleanMap = Record<string, boolean>;

export const getReportSettings = ({ reportNames, appMenuId, appMenus, userMenus }: IGetReportSettingsProps): BooleanMap => {
  const reportsParent = appMenus.find((menu) => menu.name === 'Reports' && menu.parentAppMenuId === appMenuId);
  if (!reportsParent) throw new Error(`Reports parent menu not found for menuId: ${appMenuId}`);

  const reportsMap: ReportsMap = appMenus
    .filter((menu) => menu.parentAppMenuId === reportsParent.appMenuId)
    .reduce((acc, menu) => {
      acc[menu.name] = {
        appMenuId: menu.appMenuId,
        name: menu.name,
        uiName: menu.uiName,
        parentAppMenuId: menu.parentAppMenuId!,
      };
      return acc;
    }, {} as ReportsMap);

  const hasAccess = (reportName: string) => {
    const report = reportsMap[reportName];
    return report ? userMenus.some((um) => um.appMenuId === report.appMenuId) : false;
  };

  const keys = Object.keys(reportNames as object) as Array<string>;

  let reportSettings: BooleanMap = {};

  keys.forEach((k) => {
    reportSettings[k] = hasAccess(reportNames[k]);
  });

  return reportSettings;
};
